<template>
  <v-item v-slot="{ isSelected, toggle }" :value="value" :disabled="disabled">
    <v-card
      :class="{
        'bg-surface-dim': isSelected,
        'so-radio-card--selected': isSelected,
        'so-radio-card--disabled': disabled,
      }"
      :max-width="maxWidth"
      class="so-radio-card w-100 fit-content"
      elevation="0"
      tabindex="0"
      :ripple="false"
      @click="!disabled && toggle && toggle()"
      @keyup.enter="!disabled && toggle && toggle()"
    >
      <div v-if="badge || $slots.badge" class="so-radio-card__badge">
        <slot name="badge">{{ badge }}</slot>
      </div>
      <template #title>
        <h6 class="font-weight-medium">
          <slot name="title"></slot>
        </h6>
      </template>
      <template #append>
        <v-radio
          :value-comparator="() => isSelected!"
          color="success"
          tabindex="-1"
        />
      </template>
      <div class="px-4 pb-4"><slot></slot></div>
    </v-card>
  </v-item>
</template>

<script lang="ts">
  import { defineComponent } from "vue"

  export default defineComponent({
    inheritAttrs: false,
    props: {
      modelValue: {
        type: [Number, String],
        default: null,
      },
      value: {
        type: [Number, String],
        default: undefined,
      },
      maxWidth: {
        type: String,
        default: undefined,
      },
      badge: {
        type: String,
        default: undefined,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
  })
</script>

<style scoped>
  .so-radio-card {
    border: 1px solid rgb(var(--v-theme-border));
    border-radius: var(--theme-radius);
    overflow: initial;
  }
  .so-radio-card--selected {
    border: 1px solid rgba(var(--v-theme-on-surface), 0.33) !important;
  }
  .so-radio-card--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .so-radio-card:focus-visible {
    outline: var(--theme-outline);
  }

  .so-radio-card__badge {
    position: absolute;
    padding: 0.2rem 0.75rem;
    border-radius: 1rem;
    top: -1rem;
    left: 0.5rem;
    z-index: 1;
    font-weight: var(--theme-font-weight-medium);
    background-color: rgb(var(--v-theme-caution));
  }
  .fit-content {
    height: fit-content;
  }
  :deep(.v-card-item__append) {
    padding-inline-start: 4px !important;
  }
</style>
